"use client"

import { useEffect, useState } from "react"

// Tailwind breakpoints for reference
// sm: 640px
// md: 768px
// lg: 1024px
// xl: 1280px
// 2xl: 1536px

export type ScreenSize = "xs" | "sm" | "md" | "lg" | "xl" | "2xl"

const getScreenSize = (width: number): ScreenSize => {
  if (width < 640) return "xs"
  if (width < 768) return "sm"
  if (width < 1024) return "md"
  if (width < 1280) return "lg"
  if (width < 1536) return "xl"
  return "2xl"
}

// Custom Responsive Hook based on Tailwind breakpoints & native resize
const useResponsive = () => {
  const [screen, setScreen] = useState<ScreenSize>("xs")

  useEffect(() => {
    const updateSize = () => setScreen(getScreenSize(window.innerWidth))

    updateSize()
    window.addEventListener("resize", updateSize)
    return () => window.removeEventListener("resize", updateSize)
  }, [])

  // Derived conditions
  const isMobile = screen === "xs" || screen === "sm"
  const isTablet = screen === "md"
  const isLaptop = screen === "lg"
  const isDesktop = screen === "xl" || screen === "2xl"

  const breakpoint = screen

  return {
    screen,
    isMobile,
    isTablet,
    isLaptop,
    isDesktop,
    breakpoint,
    size: breakpoint,
  }
}

export default useResponsive
